import styled from "styled-components";

export const DropdownFilterCont = styled.div<{
  open: boolean;
  inputWithBorder: boolean;
  inputWidth: number;
}>`

  input {
    width: ${({ inputWidth, inputWithBorder }) =>
      !inputWithBorder && inputWidth * 8 + "px"};
    max-width: ${({ inputWithBorder }) => !inputWithBorder && "auto"};
  }

   ul {
    top: 101%;
    z-index: 1;
    max-height: 400px;
    min-width: 100%;
     ${({ theme: { isRTL } }) => (isRTL ? "right:0" : "left:0")}}
  li:last-child{
   border-bottom: 0;
    margin-bottom: 0;
  }
  }
ul::-webkit-scrollbar {
  width: 7px;
}
ul::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 25px;
}
ul::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 25px;
}
  
  .withScroll{
    overflow-y: scroll;
  }
`;
export const ModalContent = styled.div`
  .bottomHeight {
    height: 33vh;
  }
`;
